import { RARCS } from '../config'
import { CARC_RARC_MAPPING } from '../config/carc-rarc-mapping'
import { byCode, type CodeOption } from './code-utils'

export function getBaseCarcCode(carcCode: string): string {
  const match = carcCode.match(/^[A-Za-z]+(\d+)$/)
  return match ? match[1] : carcCode
}

export function getMappedRarcOptions(
  carcCode: string,
  serverRarcValues?: string[],
): { options: CodeOption[]; rarcRequired: boolean } | null {
  const baseCode = getBaseCarcCode(carcCode)
  const mapping = CARC_RARC_MAPPING[baseCode]

  if (!mapping) {
    return null
  }

  if (mapping.rarcs.length === 0) {
    return { options: [], rarcRequired: mapping.rarcRequired }
  }

  const mappedRarcSet = new Set(mapping.rarcs)

  const options: CodeOption[] = RARCS.filter((r) => mappedRarcSet.has(r.code)).map((r) => ({
    label: `${r.code} - ${r.label}`,
    value: r.code,
    description: r.description,
    occurrences: r.occurrences ?? 0,
  }))

  if (serverRarcValues) {
    const existingValues = new Set(options.map((o) => o.value))
    const additionalOptions = serverRarcValues
      .filter((v) => mappedRarcSet.has(v) && !existingValues.has(v))
      .map((v) => ({ label: v, value: v, description: '', occurrences: 0 }))
    options.push(...additionalOptions)
  }

  return { options: options.sort(byCode), rarcRequired: mapping.rarcRequired }
}
